import * as R from "ramda";
import { DATA, AVAILABLE_CONSTRAINT } from "./constants/types.mjs";
const isDataRequest = (args) => R.or(
  R.propEq(DATA, "type", args),
  R.propEq(AVAILABLE_CONSTRAINT, "type", args)
);
export {
  isDataRequest
};
